import React, { useState } from "react";
import classes from "./PrivacySettingsMobile.module.css";
import { Container, Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import { Tabs } from "../../../../../stories/Tabs/Tabs";
import { useHistory } from "react-router-dom";
import { Arrowlinkicon, cancelIcon } from "../../../../../constant/imagePath";
import { Button } from "../../../../../stories/Button/Button";
import { Input } from "../../../../../stories/Input/Input";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../../../store/Actions/commonAction";

const PrivacySettingsMobile = () => {
  const history = useHistory();
  const [email, setEmail] = useState("abc@gmail.com");
  const [password, setPassword] = useState("");
  const [newpassword, setNewPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const activeTab = useSelector((state) => state?.commonReducer?.activeTab);
  const dispatch = useDispatch();

  const convertedActiveTab = activeTab?.includes("-")
    ? activeTab.split("-")[0] + " " + activeTab.split("-")[1]
    : activeTab;
  return (
    <div className={[classes.PrivacySettingsScreen].join(" ")}>
      <div className={[classes.mainheading, classes.mb32].join(" ")}>
        <img
          src={cancelIcon}
          className={[classes.crossimg]}
          alt="..."
          onClick={() => history.goBack()}
        />
        <p
          style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}
          className={[classes.textcenter].join(" ")}
        >
          Profile Settings
        </p>
      </div>
      <Container className={["p-0", classes.container].join(" ")}>
        <Row className={["g-0"].join(" ")}>
          <Col sm={12} className={[classes.mb32].join(" ")}>
            <Tabs
              tabsData={[
                { label: "Privacy settings", activeText: "privacy-settings" },
                { label: "Payout methods", activeText: "payout-methods" },
                { label: "Notifications", activeText: "notifications" },
              ]}
              state={{ label: convertedActiveTab }}
              setState={(item) => dispatch(setActiveTab(item?.activeText))}
            />
          </Col>
          <Col sm={12} className={[classes.mb24].join(" ")}>
            <h5
              style={{ ...Fonts.h6, color: Colors.neutralShadesOfNero }}
              className={[classes.mb8].join(" ")}
            >
              Email Address
            </h5>
            <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>
              Your email address is{" "}
              <span style={{ ...Fonts.h7, color: Colors.neutralShadesOfNero }}>
                {email}
              </span>
            </p>
          </Col>
          <Col sm={12} className={[classes.mb48].join(" ")}>
            <Input
              type="email"
              state={email}
              setter={setEmail}
              label="Email Address"
              disabled={true}
            />
            {/* <div className={[classes.updatebtn, classes.mt32].join(" ")}>
              <Button
                primary={true}
                customStyle={{ ...Fonts.b2, width: "100%", lineHeight: "20px" }}
              >
                Update Email
              </Button>
            </div> */}
          </Col>

          <Col sm={12} className={[classes.mb24].join(" ")}>
            <h4
              style={{
                ...Fonts.h4,
                color: Colors.neutralShadesOfNero,
                fontSize: "20px",
                lineHeight: "28px",
              }}
              className={[classes.mb24].join(" ")}
            >
              Password
            </h4>
            <Input
              type="password"
              state={password}
              setter={setPassword}
              label="Current password"
              placeholder={"Enter current password"}
            />
          </Col>
          <Col sm={12} className={[classes.mb24].join(" ")}>
            <Input
              type="password"
              state={newpassword}
              setter={setNewPassword}
              label="New password"
              placeholder={"Enter new password"}
            />
          </Col>
          <Col sm={12} className={[classes.mb24].join(" ")}>
            <Input
              type="password"
              state={confirmpassword}
              setter={setConfirmPassword}
              label="Confirm New password"
              placeholder={"Re-enter new password"}
            />
          </Col>

          <Col
            sm={12}
            className={[classes.saveAndCancelDiv, classes.mb24].join(" ")}
          >
            <Row>
              <Col xs={6}>
                <Button
                  primary={false}
                  customStyle={{
                    ...Fonts.b2,
                    width: "100%",
                    lineHeight: "20px",
                  }}
                >
                  Cancel
                </Button>
              </Col>
              <Col xs={6}>
                <Button
                  primary={true}
                  customStyle={{
                    ...Fonts.b2,
                    width: "100%",
                    lineHeight: "20px",
                  }}
                >
                  Save changes
                </Button>
              </Col>
            </Row>
          </Col>

          <Col sm={12} className={[classes.mb48].join(" ")}>
            <p
              style={{
                ...Fonts.p1,
                color: Colors.neutralShadesOfDimGray,
                fonstSize: "14px",
                lineHeight: "24px",
              }}
              className={[classes.mb4].join(" ")}
            >
              Can't remember your current password?
            </p>
            <LinkButtonWithIcon
              rightIcon={Arrowlinkicon}
              text="Reset password via email"
              primary={true}
              customStyle={{
                ...Fonts.p5,
                fontSize: "14px",
                lineHeight: "14px",
              }}
            />
          </Col>

          <Col sm={12} className={[classes.mb40].join(" ")}>
            <h4
              style={{
                ...Fonts.h4,
                color: Colors.neutralShadesOfNero,
                fontSize: "20px",
                lineHeight: "28px",
              }}
              className={`${classes.mb12}`}
            >
              Disable account
            </h4>

            <p
              style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
              className={[classes.mb24].join(" ")}
            >
              <span style={{ color: Colors.errorColor, ...Fonts.h7 }}>
                PLEASE NOTE!
              </span>{" "}
              This means your account will be hidden until you reactivate it by
              logging back in.
            </p>
            <Button primary={false} customStyle={{ width: "100%" }}>
              Disable the account
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default PrivacySettingsMobile;
